import {
  casinoMenuItem,
  cyberSportMenuItem,
  liveCasinoMenuItem,
  sportLiveMenuItem,
  sportMenuItem,
  tournamentsMenuItem,
} from '@/constants';
import type { GetDesktopNavMenuProps } from '@/Layouts/Header/components/Navigation/Navigation.types';

import type { NavMenuItem } from '@/types';

export const getDesktopNavMenu = ({ hasCyberCookie }: GetDesktopNavMenuProps): Array<NavMenuItem> => [
  casinoMenuItem,
  liveCasinoMenuItem,
  // TODO Временно скрываем в рамках MWL-6896
  // pokerMenuItem,
  sportMenuItem,
  sportLiveMenuItem,
  ...(hasCyberCookie ? [cyberSportMenuItem] : []),
  tournamentsMenuItem,
];
